export const comments_4504524 = {"data":{"data":[],"links":{}}}